module.exports = __webpack_public_path__ + "img/4f-ball.826dec07.png";